module.exports = __webpack_public_path__ + "img/24.de28916b.jpg";